var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkeanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 28,
    viewBox: "0 0 142 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo akeana-red",
    d: "M0.0781409 27.5L14.3771 9.39711L10.5053 6.53404L5.12135 13.5777V5.52836H14.6506V22.6482H19.4782V0.5H0L0.0781409 27.5Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.5,
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M28.8902 8.59226L22.7382 21.7621H26.7718L28.0955 18.7568H34.5453L35.869 21.7621H39.8909L33.7506 8.59226H28.8902ZM29.0528 16.5822L31.2485 11.5968H31.3923L33.5881 16.5822H29.0528Z",
    fill: "current",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M60.4591 8.59226H55.9465L49.5311 14.3989H49.2912V8.59226H45.5334V21.7613H49.2912V18.0231L51.1463 16.3524L56.0301 21.7613H60.5427L53.8515 14.4872L60.4591 8.59226Z",
    fill: "current",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M70.6971 16.2376H78.3331V13.984H70.6971V10.8904H78.9558V8.59226H66.9386V21.7613H78.9793V19.464H70.6971V16.2376Z",
    fill: "current",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M89.4908 8.59226L83.3388 21.7621H87.3724L88.6961 18.7568H95.1459L96.4696 21.7621H100.491L94.3512 8.59226H89.4908ZM89.6533 16.5822L91.8491 11.5968H91.9929L94.1886 16.5822H89.6533Z",
    fill: "current",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M115.818 16.8736H115.663L107.966 8.59226H104.663V21.7613H108.421V13.48H108.577L116.32 21.7613H119.577V8.59226H115.818V16.8736Z",
    fill: "current",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "akeanalogo",
    d: "M137.369 21.7613H141.391L135.251 8.59148H130.391L124.239 21.7613H128.273L129.597 18.756H136.046L137.369 21.7613ZM130.554 16.5822L132.75 11.5968H132.893L135.089 16.5822H130.554Z",
    fill: "current",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkeanaLogo);
export default __webpack_public_path__ + "static/media/akeana-logo.07ed603a6afc98f173caad8cba154eae.svg";
export { ForwardRef as ReactComponent };